import Vue from "vue";
import {
  Input,
  Icon,
  Tabs,
  TabPane,
  Spin,
  Breadcrumb,
  BreadcrumbItem,
  Avatar,
  Badge,
  Upload,
  Modal,
  Form,
  FormItem,
  Button,
  Tag,
  BackTop,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  ButtonGroup,
  Alert,
  Select,
  Page,
  RadioGroup,
  Radio,
  Option,
  Message,
  Checkbox,
  DatePicker,
} from "iview";

const iview = {
  install: function (Vue) {
    Vue.component("iInput", Input);
    Vue.component("Icon", Icon);
    Vue.component("Tabs", Tabs);
    Vue.component("TabPane", TabPane);
    Vue.component("Spin", Spin);
    Vue.component("Breadcrumb", Breadcrumb);
    Vue.component("BreadcrumbItem", BreadcrumbItem);
    Vue.component("Avatar", Avatar);
    Vue.component("Badge", Badge);
    Vue.component("Upload", Upload);
    Vue.component("Modal", Modal);
    Vue.component("Form", Form);
    Vue.component("FormItem", FormItem);
    Vue.component("Button", Button);
    Vue.component("Tag", Tag);
    Vue.component("BackTop", BackTop);
    Vue.component("Dropdown", Dropdown);
    Vue.component("DropdownItem", DropdownItem);
    Vue.component("DropdownMenu", DropdownMenu);
    Vue.component("ButtonGroup", ButtonGroup);
    Vue.component("Alert", Alert);
    Vue.component("i-select", Select);
    Vue.component("Page", Page);
    Vue.component("RadioGroup", RadioGroup);
    Vue.component("Radio", Radio);
    Vue.component("Option", Option);
    Vue.component("Message", Message);
    Vue.component("Checkbox", Checkbox);
    Vue.component("DatePicker", DatePicker);
  },
};
Vue.prototype.$Message = Message;
Vue.prototype.$Modal = Modal;
export default iview;
